import React from "react";
import HomeWorkListItem from "./HomeWorkListItem";
import "./HomeWorkList.scss";
import { connect } from "react-redux";
import images from "../../../../../utilities/images/images";

const HomeWorkList = ({ homeworkData }) => {
  return (
    <div className="homework_list_container">
      {homeworkData?.length === 0 ? (
        <div className="hmk-nodata-container">
          <img src={images.noHomeWorkImg} alt="no-data" />
          <div className="hmk-nodata-title"> No HomeWorks found... </div>
          <div className="hmk-nodata-descript">
            No homework assigned at the moment. You're all caught up!
          </div>
        </div>
      ) : (
        homeworkData?.map((item) => {
          return <HomeWorkListItem item={item} />;
        })
      )}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    loader: state.ui.loader,
    token: state.auth.authToken,
    tokenType: state.auth.tokenType,
    userData: state.auth.user,
    userPreference: state.userPreference,
  };
};

export default connect(mapStateToProps, null)(HomeWorkList);
